module.exports = __webpack_public_path__ + "static/white_bg1-50832a485a5ef09cec0b77e980bf9f09.svg";